/**
 * FigureLegend — what each color of a launcher figure counts, as a dot and its number. A state
 * with nothing in it is left out, so the key names only what the graphic shows.
 */

import type { ReactElement } from 'react';
import React from 'react';

import { cn } from '@/lib/utils';
import type { LauncherFigurePart } from '@/types/panels';

interface Props {
    parts: LauncherFigurePart[];
}

export const FigureLegend = ({ parts }: Props): ReactElement => (
    <span className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-occ-foreground-secondary">
        {parts.filter((part) => part.count > 0).map((part) => (
            <span
                key={part.label}
                className="flex items-center gap-1.5 whitespace-nowrap"
            >
                <span className={cn('size-2 shrink-0 rounded-full', part.fill)} />
                <span className="tabular-nums">{part.count}</span>
                {part.label}
            </span>
        ))}
    </span>
);
